import { getArray, serializeParams } from 'utils/helpers';

const signatureFromObject = (data) => {
  const params = serializeParams(data);
  return params.toString();
};

export const tagCreator = (type) => (id) => {
  if (id && typeof id === 'object') {
    return {
      type,
      id: signatureFromObject(id),
    };
  }
  if (!id) {
    return { type };
  }
  return { type, id };
};

export const updateRecentlyViewedStack = (id) => {
  const cached = localStorage.getItem('recently_viewed_list');
  const recently_viewed = cached ? getArray(JSON.parse(cached)) : [];
  const newCache = [id, ...recently_viewed.filter((v) => v !== id)]
    .slice(0, 13)
    .filter(Boolean);
  localStorage.setItem(
    'recently_viewed_list',
    JSON.stringify(newCache, null, 2),
  );
};
